import { FC } from "react";
import { BackendSetup } from "~/components/admin/operations";
import PageMeta from "~/components/common/meta";

type Props = {};

export const ScreenBackendSetup: FC<Props> = () => {
  return (
    <>
      <PageMeta
        title="Backend Setup | Art Handler"
        description="Backend Setup"
      />
      <BackendSetup />
    </>
  );
};
